<template>
  <transition name="fade" mode="out-in">
    <div v-if="subscribe" class="pt-1">
      <portable-text
        v-if="successText && successText.length > 0"
        :blocks="successText"
      />
    </div>
    <form v-else class="newsletter-femme" novalidate @submit.prevent="submit">
      <form-input
        :id="`${id}-email`"
        ref="email"
        v-model="email"
        :label="$t('input.email.label')"
        :placeholder="$t('input.email.placeholder')"
        required
        first-submit
        type="email"
      />

      <primary-button
        type="submit"
        :text="$t('action.subscribe_to_list')"
        align="center"
        :loading="loading"
        with-arrow
      />

      <transition name="appear-top">
        <p v-if="errSubscribe" class="text-color-error text-small mt-1 mb-0">
          {{ $t('footer.newsletter.error') }}
        </p>
      </transition>
    </form>
  </transition>
</template>

<script>
import FormInput from '@/components/form/Input'
import PrimaryButton from '@/components/buttons/Primary'
import PortableText from '@/components/RichText/PortableText'

import services from '@/services'

export default {
  name: 'FormKlaviyoList',
  components: {
    FormInput,
    PrimaryButton,
    PortableText,
  },
  props: {
    id: { type: String, required: true },
    successText: { type: Array, default: null },
    context: { type: String, default: 'all' },
    origin: { type: String, required: true },
  },
  data() {
    return {
      email: '',
      loading: false,
      subscribe: false,
      errSubscribe: false,
    }
  },
  computed: {
    newsletterLists() {
      const list = []
      const locale = this.$i18n.locales.find(
        (l) => l.code === this.$i18n.locale
      )

      if (
        locale['klaviyoNewsletter-h'] &&
        (this.context === 'h' || this.context === 'all')
      ) {
        list.push({
          id: 'h',
          name: 'Homme',
          newsletterId: locale['klaviyoNewsletter-h'],
        })
      }
      if (
        locale['klaviyoNewsletter-f'] &&
        (this.context === 'f' || this.context === 'all')
      ) {
        list.push({
          id: 'f',
          name: 'Femme',
          newsletterId: locale['klaviyoNewsletter-f'],
        })
      }

      list.sort((l) => l.id !== this.$route.params.context)

      return list
    },
  },
  methods: {
    submit() {
      this.subscribeToNewsletter()
      return false
    },
    subscribeToNewsletter() {
      if (this.$refs.email && !this.$refs.email.isValid) {
        return
      }

      this.errSubscribe = false
      this.loading = true

      const locale = this.$i18n.locales.find((locale) => {
        return locale.code === this.$i18n.locale
      })

      this.$track.bisSubscribe(this.email, 'subscribe', origin)

      /* eslint-disable no-undef */
      const pp = []
      for (const l of this.newsletterLists) {
        pp.push(
          services.notificationCenterService.subscribeCustomerToContext({
            email: this.email,
            context: l.id === 'f' ? 'femme' : 'homme',
            locale: locale.code.substring(0, 2),
            source: this.origin,
          })
        )
      }

      Promise.all(pp)
        .then(() => {
          this.loading = false
          this.subscribe = true
        })
        .finally(() => {
          this.loading = false
        })
        .catch((err) => {
          this.$logError.captureException(err)
          this.errSubscribe = true
        })
    },
  },
}
</script>
